/* Campaign presentation only. Shipping discounts/rates remain Shopify settings. */
(function (root, factory) {
  var campaign = factory();
  if (typeof module === 'object' && module.exports) module.exports = campaign;
  else { root.EarlyBFCampaign = campaign; campaign.mount(root, root.document); }
})(typeof window === 'object' ? window : globalThis, function () {
  'use strict';
  var selector = '.pretta-badge,.pretta-row,.pretta-buybox-benefit,.t4s-shipping-item,.t4s-sidebar-shipping .t4s-space-item-inner,.t4s-col__textSocial,.t4s-h-cat__html,.t4s-top-bar-text__item,.t4s-footer-content p,.t4s-pr__custom-liquid,.t4s-pr__richtext';
  function freeShipping(text) {
    var normalized = String(text || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').toLowerCase();
    return /\b(?:transport(?:ul)?\s+(?:este\s+)?(?:gratuit|gratis)|livrare(?:a)?\s+(?:este\s+)?(?:gratuita|gratis)|free\s+(?:shipping|delivery))\b/.test(normalized);
  }
  function shippingRanges(text) {
    // Keep surrounding delivery costs, terms, headings and links intact.
    // Decimal dots belong to prices; a sentence-ending dot ends the claim.
    var pattern = /\b(?:transport(?:ul)?\s+(?:este\s+)?(?:gratuit|gratis)|livrare(?:a)?\s+(?:este\s+)?(?:gratuit[aă]|gratis)|free\s+(?:shipping|delivery))(?=\s|[.,;:!?]|$)(?:(?:\.(?=\d))|[^.!?;|•·])*[.!?]?/giu;
    return Array.from(String(text || '').matchAll(pattern), function (match) {
      return { start: match.index, end: match.index + match[0].trimEnd().length };
    });
  }
  function shippingPolicy(config) {
    var threshold = config.freeShippingThreshold;
    return { enabled: config.freeShippingEnabled === true && Number.isSafeInteger(threshold) && threshold >= 0 &&
      config.presentmentCurrency === 'RON', threshold: threshold };
  }
  function shippingProgress(policy, state) {
    if (!policy.enabled) return { enabled: false };
    if (!state || state.phase !== 'ready' || !Number.isSafeInteger(state.total) || state.total < 0) {
      return { enabled: true, pending: true, percent: 0, complete: false };
    }
    return { enabled: true, pending: false, remaining: Math.max(0, policy.threshold - state.total),
      percent: policy.threshold === 0 ? 100 : Math.min(100, Math.floor(state.total * 100 / policy.threshold)),
      complete: state.total >= policy.threshold, empty: state.total === 0 };
  }
  function createCelebration(play, storage, campaignId) {
    var memory = new Map(), pending = new Set();
    function previous(key) {
      try {
        var saved = storage && storage.getItem(key);
        if (saved === '1' || saved === '0') memory.set(key, saved === '1');
      } catch (error) { /* Storage denied: keep the current page's baseline. */ }
      return memory.get(key);
    }
    function remember(key, above) {
      memory.set(key, above);
      try { if (storage) storage.setItem(key, above ? '1' : '0'); } catch (error) { /* No animation on an unknown initial full cart, even without storage. */ }
    }
    return function (policy, state, active) {
      if (!active || !policy.enabled) { pending.clear(); return false; }
      var view = shippingProgress(policy, state);
      if (view.pending) return false;
      var key = 'early-bf:shipping:v1:' + encodeURIComponent(campaignId || '') + ':' + policy.threshold + ':' + (state.cartId || 'unknown');
      var above = view.complete && Number.isSafeInteger(state.itemCount) && state.itemCount > 0;
      var before = previous(key);
      // A page opened with an already full cart establishes a silent baseline.
      if (before === undefined) { remember(key, above); return false; }
      if (!above) { if (before) remember(key, false); pending.delete(key); return false; }
      if (!before) { remember(key, true); pending.add(key); }
      if (!pending.has(key)) return false;
      if (play() === false) return false;
      pending.delete(key);
      return true;
    };
  }
  function mount(window, document) {
    function drawerViewport(root) {
      var visual = window.visualViewport;
      var height = visual && visual.height > 0 ? visual.height : window.innerHeight;
      var top = visual && Number.isFinite(visual.offsetTop) ? Math.max(0, visual.offsetTop) : 0;
      var nodes = root.querySelectorAll ? Array.from(root.querySelectorAll('#t4s-mini_cart')) : [];
      var owner = root.closest && root.closest('#t4s-mini_cart');
      if (owner && nodes.indexOf(owner) === -1) nodes.push(owner);
      nodes.forEach(function (node) {
        // The marker is replaced with the native cart-items fragment after
        // every AJAX render, including the first addition to an empty cart.
        var content = node.querySelector('[data-bf-cart-content-count]');
        var count = content && Number(content.getAttribute('data-bf-cart-content-count'));
        if (content && Number.isSafeInteger(count) && count >= 0) {
          var empty = String(count === 0);
          if (node.getAttribute('data-bf-cart-empty') !== empty) node.setAttribute('data-bf-cart-empty', empty);
        }
        if (!Number.isFinite(height) || height <= 0) return;
        var value = Math.floor(height) + 'px', offset = Math.floor(top) + 'px';
        if (node.style.getPropertyValue('--bf-drawer-height') !== value) node.style.setProperty('--bf-drawer-height', value);
        if (node.style.getPropertyValue('--bf-drawer-top') !== offset) node.style.setProperty('--bf-drawer-top', offset);
      });
    }
    function updateDrawerViewport() { drawerViewport(document); }
    var config = window.EarlyBFConfig || {}, policy = shippingPolicy(config);
    var cartState = window.EarlyBFCart && window.EarlyBFCart.getState();
    var shippingStorage = null;
    try { shippingStorage = window.localStorage; } catch (error) { /* Page-only fallback. */ }
    var celebrate = createCelebration(function () {
      var theme = window.T4SThemeSP;
      if (!window.T4Sconfigs || window.T4Sconfigs.enableConfetti !== true || !theme || typeof theme.CanvasConfetti !== 'function') return false;
      // Kalles initializes its canvas on the first call and animates afterwards.
      if (!document.getElementById('confettiCanvas')) theme.CanvasConfetti();
      theme.CanvasConfetti();
      return true;
    }, shippingStorage, config.campaignId);
    function celebration() {
      celebrate(policy, cartState, Boolean(window.EarlyBF && window.EarlyBF.getState().active));
    }
    document.documentElement.classList.toggle('bf-shipping-enabled', policy.enabled);
    function money(value) {
      return new Intl.NumberFormat(config.locale || 'ro-RO', { maximumFractionDigits: 2 }).format(value / 100) + ' lei';
    }
    function shippingCopy() {
      return policy.threshold === 0 ? 'Livrare gratuită.' : 'Livrare gratuită de la ' + money(policy.threshold) + '.';
    }
    function progress(root) {
      var nodes = root.querySelectorAll ? Array.from(root.querySelectorAll('[data-bf-shipping-progress]')) : [];
      if (root.matches && root.matches('[data-bf-shipping-progress]')) nodes.push(root);
      var view = shippingProgress(policy, cartState);
      nodes.forEach(function (node) {
        node.hidden = !view.enabled;
        if (!view.enabled) return;
        var message = view.pending ? 'Actualizăm coșul…' : view.complete ? 'Ai transport gratuit.' :
          view.empty ? shippingCopy() : 'Mai adaugă produse de ' + money(view.remaining) + ' pentru livrare gratuită.';
        var label = node.querySelector('[data-bf-shipping-message]');
        if (label.textContent !== message) label.textContent = message;
        node.setAttribute('data-complete', String(view.complete));
        var track = node.querySelector('[data-bf-shipping-track]');
        track.hidden = view.pending;
        track.setAttribute('aria-valuenow', String(view.percent));
        node.querySelector('[data-bf-shipping-fill]').style.width = view.percent + '%';
      });
    }
    function contentOf(node) {
      var walker = document.createTreeWalker(node, 4), entries = [], text = '', child;
      while ((child = walker.nextNode())) {
        if (child.parentElement.closest('script,style,template')) continue;
        var marked = child.parentElement.closest('[data-bf-free-shipping],[data-bf-shipping-copy]');
        if (marked && marked !== node) continue;
        if (text) text += ' ';
        entries.push({ node: child, start: text.length, end: text.length + child.nodeValue.length });
        text += child.nodeValue;
      }
      return { text: text, entries: entries };
    }
    function inspect(node) {
      if (node.matches('span[data-bf-free-shipping],[data-bf-shipping-copy]')) return;
      var content = contentOf(node), text = content.text;
      // A custom block can also contain prices, returns and other benefits.
      // Mark the specific shipping row instead of hiding the entire block.
      if (node.matches('.t4s-pr__custom-liquid,.t4s-pr__richtext') &&
          (text.length > 400 || node.querySelector('.pretta-badge,.pretta-row,.pretta-buybox-benefit'))) {
        node.removeAttribute('data-bf-free-shipping'); return;
      }
      if (!freeShipping(text)) {
        if (!node.querySelector('[data-bf-free-shipping]')) node.removeAttribute('data-bf-shipping-benefit');
        return;
      }
      // Keep the shipping icon when enabled; hide the dedicated benefit when off.
      if (node.matches('.pretta-badge,.pretta-row,.pretta-buybox-benefit')) {
        node.setAttribute('data-bf-shipping-benefit', '');
      }
      // Wrap only the claim's text fragments, preserving existing DOM elements.
      shippingRanges(text).reverse().forEach(function (range) {
        var firstSpan = null;
        content.entries.slice().reverse().forEach(function (entry) {
          var start = Math.max(range.start, entry.start) - entry.start;
          var end = Math.min(range.end, entry.end) - entry.start;
          if (start >= end) return;
          var fragment = entry.node;
          if (end < fragment.length) fragment.splitText(end);
          if (start > 0) fragment = fragment.splitText(start);
          var span = document.createElement('span');
          span.setAttribute('data-bf-free-shipping', '');
          fragment.parentNode.insertBefore(span, fragment);
          span.appendChild(fragment);
          firstSpan = span;
        });
        if (policy.enabled && firstSpan) {
          var copy = document.createElement('span');
          copy.setAttribute('data-bf-shipping-copy', '');
          copy.setAttribute('data-bf-vip-only', '');
          copy.textContent = shippingCopy();
          firstSpan.parentNode.insertBefore(copy, firstSpan);
        }
      });
    }
    function scan(root) {
      if (root.nodeType === 1) {
        var parent = root.closest(selector);
        if (parent) inspect(parent);
      }
      if (root.querySelectorAll) root.querySelectorAll(selector).forEach(inspect);
      progress(root);
      drawerViewport(root);
    }
    var observer = new window.MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.type === 'characterData') scan(record.target.parentElement);
        else {
          scan(record.target);
          record.addedNodes.forEach(function (node) { if (node.nodeType === 1) scan(node); else if (node.parentElement) scan(node.parentElement); });
        }
      });
    });
    observer.observe(document.documentElement, { subtree: true, childList: true, characterData: true });
    document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
    document.addEventListener('bf:cart-state', function (event) { cartState = event.detail; progress(document); celebration(); });
    document.addEventListener('bf:access-changed', celebration);
    window.addEventListener('resize', updateDrawerViewport);
    window.addEventListener('orientationchange', updateDrawerViewport);
    window.addEventListener('pageshow', updateDrawerViewport);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', updateDrawerViewport);
      window.visualViewport.addEventListener('scroll', updateDrawerViewport);
    }
    scan(document);
    celebration();
    return Object.freeze({ scan: scan, dispose: function () {
      observer.disconnect();
      window.removeEventListener('resize', updateDrawerViewport);
      window.removeEventListener('orientationchange', updateDrawerViewport);
      window.removeEventListener('pageshow', updateDrawerViewport);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', updateDrawerViewport);
        window.visualViewport.removeEventListener('scroll', updateDrawerViewport);
      }
    } });
  }
  return Object.freeze({ freeShipping: freeShipping, shippingRanges: shippingRanges,
    shippingPolicy: shippingPolicy, shippingProgress: shippingProgress, createCelebration: createCelebration, mount: mount });
});
